import { validate as isValidEmail } from 'email-validator'

const isNewTag = (tags: string[], newTag: string): boolean =>
  !tags.some(tag => tag.toLowerCase() === newTag.toLowerCase())

const extractValidEmails = (input: string): string[] =>
  input
    .split(',')
    .map(email => email.trim())
    .filter(email => email !== '' && isValidEmail(email))

export const getRandom = () => Math.random()

export const getUnique12Number = () =>
  Math.floor(100000000000 + Math.random() * 900000000000)

export const areAllEmailsValid = (emails: string[]): boolean =>
  emails?.every(isValidEmail)

export const getUpdatedTags = (
  emails: string[],
  newEmailsInput: string
): string[] => {
  if (!newEmailsInput) {
    return emails
  }

  if (newEmailsInput.includes(',')) {
    const validEmails = extractValidEmails(newEmailsInput)
    const existingEmails = emails.filter(email => validEmails.includes(email))
    if (existingEmails.length === validEmails.length) {
      return emails
    }
    return [...new Set([...emails, ...validEmails])]
  }

  if (isNewTag(emails, newEmailsInput) && isValidEmail(newEmailsInput)) {
    return [...emails, newEmailsInput]
  }

  return emails
}
